import React from "react";
import { useRouter } from "next/router";
import { IGroup } from "@nju/data-access-portal-dashboard";
import { IMobileOrchestrator } from "@nju/data-access-portal-orchestrator";
import { Icon } from "@nju/icons";
import { salesRoutes } from "@nju/routes";
import { Button, Text } from "@nju/ui";
import { copyToClipboard } from "@nju/utils";
import { IPhaseProps } from "../partials/types";
import { CustomerStatusAddNumberCard } from "./CustomerStatusAddNumberCard";
import { CustomerStatusMobileOrderCard } from "./CustomerStatusMobileOrderCard";

interface ICustomerStatusDetailsProps {
  groups: IGroup[] | undefined;
  phase: IPhaseProps;
  mobile: IMobileOrchestrator | undefined;
  handleRedirectMobile: () => void;
}

export function CustomerStatusDetails({
  phase,
  groups,
  mobile,
  handleRedirectMobile,
}: ICustomerStatusDetailsProps) {
  const router = useRouter();
  const msisdnCapacity = groups?.[0].metadata.capacity;

  const handleRedirectBanner = () => {
    return router.push(salesRoutes.statusKlienta.get());
  };

  const handleCopyToClipboard = React.useCallback(async (text: string) => {
    await copyToClipboard(text);
  }, []);

  if (!groups) {
    // eslint-disable-next-line unicorn/no-null
    return null;
  }

  return (
    <>
      <Button
        display="inlineFlex"
        onPress={handleRedirectBanner}
        size="inline"
        variant="simple"
      >
        <div className="flex gap-3 items-center">
          <Icon height={18} name="arrow-left" tone="accent" width={18} />
          <Text weight="bold">wróć do poprzedniej strony</Text>
        </div>
      </Button>
      <div className="grid gap-4 grid-cols-none pt-5 from-desktop:grid-cols-2">
        {groups[0].members.map((member, index) => {
          return (
            <React.Fragment key={`number-${index + 1}`}>
              <CustomerStatusMobileOrderCard
                handleCopyToClipboard={handleCopyToClipboard}
                mobile={mobile}
                phase={phase}
                primaryMsisdn={member.primaryMsisdn}
                selectedMsisdn={member.selectedMsisdn}
              />
            </React.Fragment>
          );
        })}
        {msisdnCapacity !== 0 && (
          <CustomerStatusAddNumberCard
            handleRedirectMobile={handleRedirectMobile}
            msisdnCapacity={msisdnCapacity}
          />
        )}
      </div>
    </>
  );
}
